import tpl from './javascriptApi.html';
import "./javascriptApi.css";

class JavascriptApi {
    constructor(container, opts) {
        this.container = container;
        this.container.innerHTML = tpl;
        // this.baseURL = '//' + window.location.host;
        // this.token = opts.token;
    }
}

export {
    JavascriptApi
}